export const getSalesRepList = (state: any) => state.salesRep.salesRepList;
